import { api } from '@/fsd/shared/api';
import { OrganizationFullInfo } from '../model/types/types';

export const getOrganizationsFullInfo = async (
  id: number
): Promise<OrganizationFullInfo> => {
  const data = await api.get<{ data: OrganizationFullInfo }>(
    `/api/v1/organisation/${String(id)}`
  );

  return data.data;
};
